<template>
  <input v-bind="$attrs" type="file" accept="*" @change="readFile"/>
</template>

<script>
import { readInputFile } from '../../utils';
export default {
	methods: {
		readFile({target}) {
      let file = target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
				target.value = "";
        let imageAsEncoded64 = reader.result.split(",")[1];
				this.$emit('input', { name: file.name, content: imageAsEncoded64 });
      };
		},
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/FileInput.vue